import { Text } from 'components'
import { CreateLocationInput } from 'components/Location/LocationCreationModal'
import { ErrorMessage } from 'components/Form'
import { AddIcon } from 'components/Icon'
import { useBoolean } from 'hooks'
import { useEffect, useState } from 'react'
import { Box, Flex } from 'theme-ui'
import { LocationSearchInput } from 'components/Location/LocationSearchInput'
import { noop } from 'utils'

export type AddLocationInputProps = {
  currLocations: string[]
  countryCode?: string
  onClick: () => void
  addLocation: (id: string) => void
  hideDetails?: boolean
  tabIndex?: number
}

export const AddLocationInput = ({
  currLocations,
  countryCode,
  onClick = noop,
  addLocation,
  hideDetails = false,
  tabIndex,
}: AddLocationInputProps) => {
  const [shouldShow, , hide, toggle] = useBoolean(false)
  const handleLocationPicked = (id: string) => {
    addLocation(id)
    hide()
  }
  useEffect(() => {
    hideDetails && hide()
  }, [hideDetails, hide])
  const [error, setError] = useState<string>('')

  return (
    <>
      <Box
        variant="forms.inputGroup.fullWidth"
        sx={{
          width: ['unset', 1000],
          maxWidth: ['unset', 'calc(((100vw - 810px) / 2) + 770px)'],
        }}>
        <Text
          variant="text.accent"
          sx={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
          onClick={() => {
            toggle()
            onClick()
          }}>
          <AddIcon
            sx={{ display: 'inline-flex', alignItems: 'center', pr: '9px' }}
          />
          Add a new location
        </Text>
        {shouldShow ? (
          <Flex
            sx={{
              pt: 30,
              justifyContent: 'space-between',
              flexWrap: ['wrap', 'nowrap'],
              alignItems: 'flex-end',
            }}>
            <Box
              sx={{
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: [335, 640],
                mr: 27,
              }}>
              <LocationSearchInput
                currLocations={currLocations}
                countryCode={countryCode}
                onLocationPicked={handleLocationPicked}
                tabIndex={tabIndex}
                onError={setError}
              />
            </Box>

            <Box
              sx={{
                flexBasis: [240],
                flexGrow: 0,
                flexShrink: 1,
                pt: [27, 'unset'],
              }}>
              <CreateLocationInput
                countryCode={countryCode}
                onLocationCreated={handleLocationPicked}
              />
            </Box>
          </Flex>
        ) : null}
        <ErrorMessage>{error ? <span>{error}</span> : null}</ErrorMessage>
      </Box>
    </>
  )
}
